import React from "react";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import CarrierTracking from '../../pages/General/CarrierTracking'

const MultipleTracking = ({ dispatchCallback, trackingItems = [], carrierImageWidth = null, moreCallBack , orderData = null, is_multi_piece}) => {
    // Basic cleanup
    if (trackingItems.raw_data) delete trackingItems["raw_data"];

    const initiateTracking = (carrier_name, tracking_number, message = null, is_multi_piece) => {
        if (typeof dispatchCallback === 'function') {
            dispatchCallback(carrier_name, tracking_number, message, is_multi_piece)
        }
    }

    let distinctTrackingNumbers = [];
    let prevTrackingNumbers = [];
    let allShipmentsClosed = true;

    // Data Parsing
    trackingItems.forEach((text) => {
        let carrier_name = (text.fulfilment_company?.trim()) ? text.fulfilment_company : "";
        let tracking_numbers = [];

        if (text.tracking_numbers && text.tracking_numbers.length > 0) {
            tracking_numbers = text.tracking_numbers;
        } else if (text.tracking_number) {
            tracking_numbers = [text.tracking_number];
        }

        if (text.shipments && Array.isArray(text.shipments)) {
            text.shipments.forEach(ship => {
                if (ship.is_closed === false) allShipmentsClosed = false;
            });
        }

        tracking_numbers.forEach((tkn) => {
            if (!prevTrackingNumbers.includes(tkn)) {
                prevTrackingNumbers.push(tkn);
                let itemMessage = !allShipmentsClosed ? "This shipment manifest is not yet closed" : null;

                distinctTrackingNumbers.push({ 
                    "tracking_number": tkn, 
                    "carrier_name": carrier_name, 
                    "message": itemMessage 
                });
            }
        });
    });

    // 1. Get only the first tracking record
    const firstTracking = distinctTrackingNumbers[0];
    // 2. Check if there are more remaining
    const hasMore = distinctTrackingNumbers.length > 1;

    return (
        <div className="user-card" style={{ display: 'flex', alignItems: 'center' }}>
            {firstTracking && (
                <CarrierTracking 
                    trackingItems={firstTracking} 
                    carrierImageWidth={carrierImageWidth} 
                    dispatchCallback={initiateTracking} 
                    message={firstTracking.message} 
                    is_multi_piece={is_multi_piece} 
                />
            )}
            
            {/* Show "More" icon only if there are multiple tracking numbers */}
            {hasMore && (
                <Tooltip title="View More Shipments">
                    <IconButton onClick={moreCallBack} style={{ cursor: "pointer", marginLeft: '4px' }}>
                        <MoreVertIcon />
                    </IconButton>
                </Tooltip>
            )}
        </div>
    );
};

export default MultipleTracking;